import React from 'react';
import { Badge, BadgeProps, ClockIcon, DisplayText, TitleText } from '@paypalcorp/pp-react';
import styles from './CustomizePageHeader.module.less';
import cx from 'classnames';

type Tag = {
  type: BadgeProps['type'];
  contrast?: BadgeProps['contrast'];
  label: string;
};
type ContentJson = {
  tags: Tag[];
  lastUpdated: string;
  title: string;
};
type EcmContent = {
  content: string;
  jsonObject: ContentJson;
};
type CustomizePageHeaderProps = {
  ecmContent: EcmContent;
  latestUpdateTime: Date;
};

const CustomizePageHeader = ({ ecmContent, latestUpdateTime }: CustomizePageHeaderProps) => {
  function addOrdinalSuffix(day: number): string {
    if (day >= 11 && day <= 13) return `${day}th`;
    switch (day % 10) {
      case 1:
        return `${day}st`;
      case 2:
        return `${day}nd`;
      case 3:
        return `${day}rd`;
      default:
        return `${day}th`;
    }
  }

  const latestUpdatedCalc: string = latestUpdateTime
    ? `Latest updated: ${latestUpdateTime.toLocaleString('en-US', {
        month: 'short'
      })} ${addOrdinalSuffix(latestUpdateTime.getDate())}, ` +
      latestUpdateTime
        .toLocaleString('en-US', {
          hour: 'numeric',
          minute: 'numeric',
          hour12: true
        })
        .replace(' AM', 'am')
        .replace(' PM', 'pm')
    : '';

  const { jsonObject: { tags = [], lastUpdated = '', title = '' } = {} } = ecmContent;

  return (
    <div className={cx([styles.container, 'customize-header'])}>
      <DisplayText size="sm" className={styles.title}>
        {title}
      </DisplayText>
      <div className={styles.badges_row}>
        {tags.map((tag) => {
          return (
            <Badge size="large" type={tag.type} contrast={tag.contrast} key={tag.label}>
              {tag.label}
            </Badge>
          );
        })}
        <ClockIcon className={styles.clock_icon} />
        <TitleText>{lastUpdated || latestUpdatedCalc}</TitleText>
      </div>
    </div>
  );
};

export default CustomizePageHeader;
